import {
  communicationQuestions,
  securityQuestions,
  akceUsageQuestions,
  membershipQuestions,
  personalInforQuestions,
  questionnaireQuestions,
  otherQuestions,
} from "./sub-data";
const faqsTabContent = [
  {
    title: "Membership",
    eventKey: "membership",
    details: [...membershipQuestions],
  },
  {
    title: "Questionnaire",
    eventKey: "questionnaire",
    details: [...questionnaireQuestions],
  },
  {
    title: "AkçeUsage",
    eventKey: "akceUsage",
    details: [...akceUsageQuestions],
  },
  {
    title: "Personal Info",
    eventKey: "personalInformation",
    details: [...personalInforQuestions],
  },
  {
    title: "Communication",
    eventKey: "communication",
    details: [...communicationQuestions],
  },
  {
    title: "Security",
    eventKey: "security",
    details: [...securityQuestions],
  },
  {
    title: "Other",
    eventKey: "other",
    details: [...otherQuestions],
  },
];

export default faqsTabContent;
